import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Book } from 'lucide-react';
const TOMOS = [{
  title: 'TOMO 1: Diagnóstico del Sueño',
  subtitle: 'Entendé qué está saboteando el sueño de tu bebé.',
  desc: 'Hacé tu propio diagnóstico en minutos y descubrí la causa real del problema.'
}, {
  title: 'TOMO 2: Ventanas Perfectas',
  subtitle: 'Sabé exactamente cuándo dormirlo según su edad.',
  desc: 'Tabla de ventanas de sueño de 4 a 24 meses + señales de cansancio que casi nadie ve.'
}, {
  title: 'TOMO 3: Ritual de Noche',
  subtitle: 'La rutina para bajar revoluciones y que se duerma más fácil.',
  desc: 'Estructura de 6 pasos usando luz, sonido y temperatura a tu favor.'
}, {
  title: 'TOMO 4: Pase a la Cuna',
  subtitle: 'Pasalo de brazos a cuna sin que se despierte.',
  desc: 'Protocolo de 8 pasos para el traslado sin arruinar todo en el último segundo.'
}, {
  title: 'TOMO 5: Rescate Nocturno',
  subtitle: 'Qué hacer cuando se despierta a la 1AM, 3AM o 5AM.',
  desc: 'Protocolo específico para cada hora + programa de 4 semanas para reducir despertares.'
}, {
  title: 'TOMO 6: Plan 7 Noches',
  subtitle: 'Tu hoja de ruta para empezar esta misma noche.',
  desc: 'Plan noche por noche con expectativas reales y ajustes si algo no funciona.'
}];
const BONUSES = [{
  title: 'BONUS 1: Detector de Bloqueos del Sueño',
  value: '$15.000',
  desc: 'Tu herramienta de diagnóstico rápido para cualquier noche que algo falle. Funciona como un árbol de decisiones: respondés 7 preguntas y en menos de 5 minutos sabés exactamente qué salió mal y qué ajustar. Cubre los 7 bloqueos más comunes: sobrecansancio, ventana incorrecta, sobreestimulación, ritual inconsistente, causa física, regresión y cambio de ambiente.',
  img: 'https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=400&q=80'
}, {
  title: 'BONUS 2: Protocolo Madrugada',
  value: '$15.000',
  desc: 'Tu guía de acción inmediata para usar en el momento exacto del despertar nocturno. Incluye el protocolo específico para la 1AM, las 3AM y las 5AM, la escala de intervención de 5 niveles y las tarjetas de protocolo para tener al lado de la cama. Diseñado para funcionar cuando tu cerebro no está al 100%.',
  img: 'https://images.unsplash.com/photo-1576633587382-13ddf37b1fc1?w=400&q=80'
}, {
  title: 'BONUS 3: Traductor de Llanto y Señales',
  value: '$15.000',
  desc: 'Aprendé a leer lo que tu bebé te dice antes de que llegue al llanto. Incluye el mapa completo de señales de sueño por edad, el traductor de los 5 tipos de llanto, la guía para diferenciar hambre de sueño y las señales de sobrecarga sensorial.',
  img: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=400&q=80'
}];
export function IncludesSection() {
  return <section className="bg-white py-24 px-4" data-id="element-143">
      <div className="max-w-5xl mx-auto" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-navy mb-6" data-id="element-146">
            Todo lo que recibís cuando elegís el Método Noches de Paz™
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xl text-navy/80 max-w-3xl mx-auto" data-id="element-147">
            Cuando accedés hoy, recibís un sistema completo de 6 tomos y 3 bonus
            diseñados para acompañarte en cada etapa del proceso. Cada material
            tiene un propósito específico y juntos forman un sistema integrado
            que cubre desde el diagnóstico hasta la implementación completa.
          </motion.p>
        </div>

        <h3 className="text-2xl font-bold text-center text-navy mb-10" data-id="element-148">
          LOS 6 TOMOS PRINCIPALES
        </h3>

        <div className="grid md:grid-cols-2 gap-6 mb-20" data-id="element-149">
          {TOMOS.map((tomo, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-warm-white p-8 rounded-2xl shadow-soft border border-soft-gray" data-id="element-150">
              <h4 className="text-xl font-bold text-navy mb-2 flex items-center gap-2" data-id="element-151">
                <Book className="text-sky" size={20} data-id="element-152" /> {tomo.title}
              </h4>
              <p className="text-sky font-medium mb-3" data-id="element-153">{tomo.subtitle}</p>
              <p className="text-navy/70" data-id="element-154">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-navy-dark text-white rounded-3xl p-8 md:p-12 shadow-premium relative overflow-hidden" data-id="element-155">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-156"></div>

          <h3 className="text-3xl font-bold text-center mb-12 relative z-10" data-id="element-157">
            LOS 3 REGALOS INCLUIDOS
          </h3>

          <div className="grid md:grid-cols-3 gap-8 relative z-10" data-id="element-158">
            {BONUSES.map((bonus, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-white/10 p-6 rounded-2xl backdrop-blur-sm border border-white/10 flex flex-col" data-id="element-159">
                <a href="#compra" className="block mb-4 overflow-hidden rounded-xl relative group" data-id="element-160">
                  <div className="absolute top-2 left-2 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full z-10 shadow-lg" data-id="element-161">
                    GRATIS POR EL DÍA DE HOY
                  </div>
                  <img src={bonus.img} alt={bonus.title} loading="lazy" className="w-full aspect-[4/3] object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-162" />
                </a>
                <h4 className="text-xl font-bold text-gold mb-2 flex items-start gap-2" data-id="element-163">
                  <span data-id="element-164">🎁</span> {bonus.title}
                </h4>
                <p className="text-sm text-white/50 mb-4 line-through" data-id="element-165">
                  Valor percibido: {bonus.value}
                </p>
                <p className="text-white/80 text-sm leading-relaxed flex-grow" data-id="element-166">
                  {bonus.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}